import Component from "@glimmer/component";
import getURL from "discourse-common/lib/get-url";
import { i18n } from "discourse-i18n";

export default class WazeBotAuthorsSettings extends Component {
  get category() {
    return this.args.outletArgs.category;
  }

  get parentCategory() {
    return this.category?.parentCategory;
  }

  get botUserId() {
    return this.category?.custom_fields?.waze_bot_author_id;
  }

  get parentCategoryBotUserId() {
    return this.parentCategory?.custom_fields?.waze_bot_author_id;
  }

  get parentCategoryHasBot() {
    return (
      this.parentCategoryBotUserId != null &&
      this.parentCategory?.custom_fields?.waze_enable_bot_author
    );
  }

  get isBotEnabled() {
    return (
      this.args.outletArgs.transientData?.custom_fields
        ?.waze_enable_bot_author ??
      this.category?.custom_fields?.waze_enable_bot_author
    );
  }

  get shouldShowBotLink() {
    return this.isBotEnabled && this.botUserId != null;
  }

  get botUserAdminPageUrl() {
    return getURL(`/admin/users/${this.botUserId}/_`);
  }

  <template>
    {{#if @outletArgs.category.all_topics_wiki}}
      <@outletArgs.form.Object @name="custom_fields" as |object|>
        <@outletArgs.form.Section
          @title={{i18n "waze_bot_authors.settings.section_title"}}
        >
          <object.Field
            @name="waze_enable_bot_author"
            @title={{i18n "waze_bot_authors.settings.enable_bot_author"}}
            @type="checkbox"
            @format="max"
            as |field|
          >
            <field.Control />
          </object.Field>
          <b>{{i18n
              "waze_bot_authors.settings.enable_bot_author_description"
            }}</b>

          {{#if this.isBotEnabled}}
            <object.Field
              @name="waze_bot_category_type"
              @title={{i18n "waze_bot_authors.settings.bot_type"}}
              @type="select"
              as |field|
            >
              <field.Control as |select|>
                {{#if this.parentCategoryHasBot}}
                  <select.Option @value="1">
                    {{i18n "waze_bot_authors.settings.parent_category_bot"}}
                  </select.Option>
                {{/if}}
                <select.Option @value="2">
                  {{i18n "waze_bot_authors.settings.local_category_bot"}}
                </select.Option>
              </field.Control>
            </object.Field>
          {{/if}}

          {{#if this.shouldShowBotLink}}
            <br />
            <a href="{{this.botUserAdminPageUrl}}">
              {{i18n "waze_bot_authors.settings.admin_link"}}
            </a>
          {{/if}}
        </@outletArgs.form.Section>
      </@outletArgs.form.Object>
    {{/if}}
  </template>
}
